import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { throwError } from 'rxjs';
import { NotificationService } from './notificacion.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStoreService } from './local-store.service';
import Swal from 'sweetalert2';
import { isJwtExpired } from './jwt.utils';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private sessionExpiredShownSubject = new BehaviorSubject<boolean>(false);
	constructor(
		private _router: Router,
		private authservice: AuthService,
		private spinner: NgxSpinnerService,
		private modalService: NgbModal,
		private ls: LocalStoreService,
	) {}

	intercept(
		httpRequest: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		const user = this.ls.getItem('currentUserPortal');
		const token = user?.token;
		const isAuthCall = httpRequest.url.includes('/auth/authenticate');

		if (!isAuthCall && token && isJwtExpired(token)) {
			// avoid spamming dialogs; just sign out
			this.modalService.dismissAll();
			this.spinner.hide();
			this.authservice.signout();
			// console.log('Token Expired');

			return throwError(
				() =>
					new HttpErrorResponse({
						status: 401,
						statusText: 'Token expired',
					}),
			);
		}

		return next.handle(httpRequest).pipe(
			catchError((error) => {
				if (error.status == 401) {
					if (!this.sessionExpiredShownSubject.value) {
						this.sessionExpiredShownSubject.next(true);
						this.modalService.dismissAll();
						this.spinner.hide();
						Swal.fire({
							title: 'Sesión expirada',
							text: 'Será redirigido al inicio de sesión en unos segundos.',
							icon: 'warning',
							timer: 5000,
							timerProgressBar: true,
							backdrop: true,
							showConfirmButton: false,
							onClose: () => {
								this.sessionExpiredShownSubject.next(false);
								this.authservice.signout();
							},
						});
					}
				} else if (error.status == 403) {
					this.modalService.dismissAll();
					this.spinner.hide();
					Swal.fire({
						title: 'Acceso denegado',
						text: 'No tiene permisos para realizar esta acción. Será redirigido al inicio en unos segundos.',
						icon: 'error',
						allowOutsideClick: false,
						allowEscapeKey: false,
						timer: 2500,
						timerProgressBar: true,
					}).then(() => {
						// this.sessionExpiredShownSubject.next(false);
						// this.authservice.signout(); // should redirect
						// console.log('Access denied - redirecting to home');
						return throwError(() => error);
					});
				} else {
					this.spinner.hide();
					return throwError(error);
				}
			}),
		);
	}
}
